@if (indicator && dataLayerType) {
  <div
    class="flex gap-2 white-space-nowrap"
    [ngClass]="{
      'p-button-xs p-button p-button-secondary p-button-text p-button-raised p-button-rounded':
        !readonly,
    }"
    (click)="menu.toggle($event)">
    <!--<app-data-layer-type-icon
      [dataLayerType]="dataLayerType"></app-data-layer-type-icon>-->
    <span style="text-overflow: ellipsis; overflow: hidden">
      @if (activeGroup) {
        <span>{{
          dataLayerType.name + ' (' + activeGroup + '): ' + indicator.name
        }}</span>
      } @else {
        {{ dataLayerType.name + ': ' + indicator.name }}
      }
    </span>
    @if (!readonly) {
      <i class="fas fa-chevron-down text-xs"></i>
    }
  </div>
  <p-tieredMenu appendTo="body" #menu [model]="indicatorMenu" [popup]="true" />
}
